import _ from "lodash";

import {
  Component,
} from "react";
import {
  ListGroupItem,
} from "react-bootstrap";
import {
  Awesome,
  Panel,
  Spinner,
  Tooltip,
} from "CommonComponents/bricks";
import apifetch from "CommonCore/apifetch";
import store from "CommonState/store";
import {
  Link,
} from "react-router-dom";
import {
  ANTRAGSTELLERMODUS,
  ASTMODUSKEY,
} from "App/constants";
import {
  renderChildren,
} from "CommonCore/router-util";

export class AngabenItem extends Component {
  wrapLink(component, linkcolor) {
    const { to } = this.props;
    return to ? <Link style={{ textDecoration: "none", color: linkcolor || undefined }} to={to}>{component}</Link> : component;
  }

  render() {
    const { status, arrays } = this.props;

    let count = 0;
    _.map(arrays, name => {
      if (!_.isEmpty(status[name])) {
        count += status[name].length;
      }
    });

    if (count > 0) {
      return <tr>
        <td className='td-fit' style={{ verticalAlign: "middle", paddingRight: "0.5em", textAlign: "center" }}><Tooltip placement='right' overlay={`In diesem Bereich ${ count == 1 ? "muss" : "müssen" } noch ${ count } Angabe${ count != 1 ? "n" : "" } gemacht werden`}><Awesome style={{ color: "#3498db", fontSize: "150%" }} name='exclamation fa-4x' /></Tooltip> </td>
        <td>{this.wrapLink(<ListGroupItem style={{ marginTop: "4px", backgroundColor: "#e0e0e0" }}>{renderChildren(this.props)}<div className='float-end'>Bitte vervollständigen</div></ListGroupItem>)}</td>
      </tr>;
    }

    return <tr>
      <td className='td-fit' style={{ verticalAlign: "middle", paddingRight: "0.5em" }}><Awesome name='check' style={{ fontSize: "150%" }} /></td>
      <td>{this.wrapLink(<ListGroupItem style={{ marginTop: "4px", backgroundColor: "#e0e0f4" }}>{renderChildren(this.props)}<div className='float-end'>Fertig</div></ListGroupItem>, "black")}</td>
    </tr>;
  }
}


export async function updateStats(props, forceModus) {
  const { AntragstellerModus, flag_antragstellermodus } = props;
  const modus = forceModus || AntragstellerModus || flag_antragstellermodus;
  if (modus != undefined) {
    const data = await apifetch(`/api/shkperson/angabenstatus?modus=${ modus }`);
    props.setFlag("angabenstatus", data);
    return data;
  }
  return null;
}

@store("flag_angabenstatus")
export default class DashboardWidgetAngaben extends Component {
  constructor() {
    super();
  }
  componentDidMount() {
    // Via Service ermitteln, welche Angaben zur Person bereits erfasst sind
    updateStats(this.props);
  }

  render() {
    const { AntragstellerModus, flag_angabenstatus: status } = this.props;

    const werkvertrag = AntragstellerModus == ASTMODUSKEY.WerkPrivat;
    const lehrvertrag = AntragstellerModus == ASTMODUSKEY.Lehrauftrag;
    const tarifvertrag = AntragstellerModus == ASTMODUSKEY.Tarif;
    const vortragvertrag = AntragstellerModus == ASTMODUSKEY.Vortrag;
    const modus = ANTRAGSTELLERMODUS[AntragstellerModus];

    const AngabenItems = () => {
      const angabenItems = [];
      angabenItems.push(
        <AngabenItem key='stamm' to='/person/stamm' status={status} arrays={["person"]}>
          Persönliche Daten
        </AngabenItem>,
      );

      if (!werkvertrag && !vortragvertrag) {
        angabenItems.push(
          <AngabenItem key='studium' to='/person/studium' status={status} arrays={["studienbereich", "werdegang"]}>
            {lehrvertrag ? "Qualifikation" : tarifvertrag ? "Ausbildung" : "Studentische / Wissenschaftliche Daten"}
          </AngabenItem>,
        );

        if (!lehrvertrag) {
          angabenItems.push(
            <AngabenItem key='steuer' to='/person/steuer' status={status} arrays={["lbvperson"]}>
              LBV 1. Persönliche Daten
            </AngabenItem>,
          );
          angabenItems.push(
            <AngabenItem key='status' to='/person/status' status={status} arrays={["lbvstatus"]}>
              LBV 2. Status
            </AngabenItem>,
          );

          angabenItems.push(
            <AngabenItem key='weiterebv' to='/person/weiterebv' status={status} arrays={["weiterebv"]}>
              vorherige / weitere Beschäftigungsverhältnisse
            </AngabenItem>,
          );
        }
      }
      return angabenItems;
    };

    return <Panel>
      <h3>Meine persönlichen Angaben</h3>
      Um einen {modus.labelAntrag} einreichen zu können,
      müssen alle persönlichen Angaben vollständig erfasst sein.
      <br /><br />
      {_.isEmpty(status) && <Spinner />}
      {!_.isEmpty(status) &&

        <table style={{ width: "100%" }}>
          <tbody>
            {AngabenItems()}
          </tbody>
        </table>
      }

    </Panel>;
  }
}
